import { skipToken, useQuery } from '@tanstack/react-query';

import { ShortUrl } from '@air/api';
import { callAirApi } from '@air/utils-api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type UseGetShortUrlForCollectionParams = {
  collectionId: string;
};

export const SHORT_URL_FOR_COLLECTION_KEY = 'SHORT_URL_FOR_COLLECTION_KEY';
export type ShortUrlForCollectionKey = [typeof SHORT_URL_FOR_COLLECTION_KEY, UseGetShortUrlForCollectionParams];

export const getShortUrlForCollectionKey = (params: UseGetShortUrlForCollectionParams): ShortUrlForCollectionKey => [
  SHORT_URL_FOR_COLLECTION_KEY,
  { collectionId: params.collectionId },
];

export const useGetShortUrlForCollection = ({ collectionId }: UseGetShortUrlForCollectionParams) => {
  const { currentWorkspace } = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;

  return useQuery({
    queryKey: getShortUrlForCollectionKey({ collectionId }),
    queryFn:
      collectionId && workspaceId
        ? () => callAirApi(() => ShortUrl.getShortIdForCollection({ workspaceId, id: collectionId }))
        : skipToken,
    enabled: !!collectionId && !!workspaceId,
  });
};
